import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

// Workaround to obtain something like global variables without complex state management
// See here: https://techformist.com/global-variables-functions-vue/

// This is an array that contains 0 and 1 entries depending on whether the values (of the highlight owning node) are within the range of the highlight
// Initially, the array is empty
// The array gets set in the function highlightSelectedRange()
// The globalHighlightArray has the length of the sample size (e.g. 10000)
Vue.prototype.$globalHighlightArray = [];

// This array of arrays is set in the plotDetailPopUpGraph
// It is equal to the matrix that is passed into plotDetailPopUpGraph
// plotDetailPopUpGraph is either called from the VueDistPreview with the arrayvalues (time slice * samples)
// ... or it is called from within the PopUp but then using this variable here
// It just stores all the time slice * sample values of the node that is highlight owner
Vue.prototype.$globalTempHighlightArray = [];

Vue.prototype.$eventHub = new Vue();

// Changes here also need to be reflected in the Menue.vue where we clear all and reset values to defaults.
Vue.prototype.$globalSharedData = {
  
  arrayOfNamesOfCurrentlyExistingModulesWithOutputNode: [], // to be shared with ModuleComponent to be reflected in selection options
  selectedPeriod: 0, // zero-indexed
  numberOfPeriods: 1, // default is one

  idOfNodeThatOwnsHighlight: undefined, // this is undefined by default
  idOfNodeThatOwnsPeriodSelection: undefined, // this is undefined by default

  // Below: not yet used; not sure if we can get it or need it
  uuidOfNodeThatOwnsHighlight: undefined, // this uuid corresponds to the uuid in the globalNodeData (it is updated after every compile!)
  nameOfNodeThatOwnsHighlight: undefined, // this is undefined by default
  uidOfVueDistPreviewThatOwnsHighlight: undefined, // this is undefined by default
  // Range Slider
  lastSliderPositionLowerBoundAsString: undefined, // this is undefined by default
  lastSliderPositionUpperBoundAsString: undefined, // this is undefined by default
  // Period Slider
  lastPeriodSliderPositionLowerBoundAsString: undefined, // this is undefined by default
  lastPeriodSliderPositionUpperBoundAsString: undefined, // this is undefined by default
  defaultPopupName: 'Distribution details',
  klDivergenceArray: [], // This array holds klDivergence infos of nodes

  // To be deleted below? Check if still in use...
  extractData: {}, // This object will be filled with information from each node when processing then
  nodeData: {}, // This object contains all data of all nodes; keys are the node IDs; written by the nodes themselves

  // NEW
  globalNodeData: {},       // contains the node's data, updated during each compile by all node workers
  // globalTreeData: {},       // contains each node's predecessors, updated during each compile by all node workers
  // globalListOfNodesWithNoSuccessor: [], // list of end nodes, updated after each compile when the globalTreeData has been written and can be traversed

  nodeToModuleNameDict: {},

};

new Vue({
  render: h => h(App),
}).$mount('#app')
